import { ParkingContract } from './parkingContract';

// 주차면 기본 정보 (parking_spaces 컬렉션)
export interface ParkingSpace {
  id: string;
  spaceNumber: string; // 주차면번호 (예: "A01", "B02")
  status: 'occupied' | 'preparing' | 'vacant' | 'contracting'; // 입주중, 준비중, 공실, 계약진행
  currentContractId?: string; // 현재 이용 계약 ID (parking_contracts 컬렉션 참조)
  createdAt: Date;
  updatedAt: Date;
}

// 통합 뷰 타입 (UI용)
export interface ParkingSpaceWithContract {
  // 주차면 기본 정보
  id: string;
  spaceNumber: string;
  status: 'occupied' | 'preparing' | 'vacant' | 'contracting';
  currentContractId?: string;
  createdAt: Date;
  updatedAt: Date;
  
  // 현재 이용 계약 정보 (있는 경우)
  currentContract?: ParkingContract;
}

export interface ParkingSpaceFormData {
  spaceNumber: string;
  status: 'occupied' | 'preparing' | 'vacant' | 'contracting';
  // 계약 정보 (새로운 구조)
  userName?: string;
  userPhoneNumber?: string;
  userOrganization?: string;
  startDate?: string;
  endDate?: string;
  vehicleInfo?: string;
  notes?: string;
}

export const PARKING_STATUS_LABELS = {
  occupied: '사용중',
  preparing: '준비중',
  vacant: '공실',
  contracting: '계약진행'
} as const;

export const PARKING_STATUS_COLORS = {
  occupied: 'bg-red-100 text-red-800',
  preparing: 'bg-yellow-100 text-yellow-800',
  vacant: 'bg-green-100 text-green-800',
  contracting: 'bg-blue-100 text-blue-800'
} as const; 